import { render, staticRenderFns } from "./i4pro-treeview.vue?vue&type=template&id=4cf3e96f&scoped=true"
import script from "./i4pro-treeview.vue?vue&type=script&lang=js"
export * from "./i4pro-treeview.vue?vue&type=script&lang=js"
import style0 from "./i4pro-treeview.vue?vue&type=style&index=0&id=4cf3e96f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf3e96f",
  null
  
)

export default component.exports